// extracted by mini-css-extract-plugin
export default {"imageWrapper":"UI-z","twoColumnImage":"VI-z"};